/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Weclapp_Time_Filter_Date_RangeInputs */



/**
* | output |
* | --- |
* | "Date range" |
*
* @param {Spaces_Weclapp_Time_Filter_Date_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_weclapp_time_filter_date_range = /** @type {((inputs?: Spaces_Weclapp_Time_Filter_Date_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Weclapp_Time_Filter_Date_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datumsbereich")
	return /** @type {LocalizedString} */ ("Date range")
});